// eslint-disable-next-line react-hooks/exhaustive-deps
import React, { useState, useRef, useEffect } from "react";

import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import { ReactComponent as HiChevronDown } from "../../assets/MainPage/addBlock/countDown/arrow-down.svg";
import {ReactComponent as WatchIcon} from "../../assets/MainPage/addBlock/countDown/clock.svg";
import moment from "moment";

const TimePicker = ({ handleTimeChange, prevData }) => {
  const [selectedHour, setSelectedHour] = useState(12);
  const [selectedMinute, setSelectedMinute] = useState(0);
  const [selectedPeriod, setSelectedPeriod] = useState("AM");
  const hourScrollRef = useRef(null);
  const minuteScrollRef = useRef(null);
  const [showTimePicker, setShowTimePicker] = useState(true);
  const [openHour, setOpenHour] = useState(false);
  const [openMin, setOpenMin] = useState(false);
  const [openPeriod, setOpenPeriod] = useState(false);
  const inputRef = useRef(null);

  const [hScrollPossition, setHScrollPossition] = useState(0);
  const [mScrollPossition, setMScrollPossition] = useState(0);

  useEffect(() => {
    if (prevData) {
      let prevTime = moment(prevData, "h:mm A").format("hh:mm:A").split(":");
      setSelectedHour(prevTime?.[0]);
      setSelectedMinute(prevTime[1]);
      setSelectedPeriod(prevTime[2]);
      console.log(prevTime?.[0], prevTime?.[1], prevTime?.[2]);
    }
  }, [prevData]);


  useEffect(() => {
    handleTimeChange(`${selectedHour}:${selectedMinute} ${selectedPeriod}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedHour, selectedMinute, selectedPeriod]);

  const handleScrollHour = (scrollRef, scrollValueSetter, actionType) => {
    const scrollHeight = scrollRef.current.scrollHeight;
    const clientHeight = scrollRef.current.clientHeight;

    if (actionType === "Down") {
      let CHeight = clientHeight / 5;

      scrollRef.current.scrollTop = scrollRef.current.scrollTop + CHeight;
    }
    if (actionType === "Up") {
      let CHeight = clientHeight / 5;

      scrollRef.current.scrollTop = scrollRef.current.scrollTop - CHeight;
    }
    const scrollValue = Math.round(
      (scrollRef.current.scrollTop / (scrollHeight - clientHeight)) * 12
    );
    setHScrollPossition(hourScrollRef.current.scrollTop);
    scrollValueSetter(scrollValue === 0 ? 12 : scrollValue);
  };
  const handleScroll = (scrollRef, scrollValueSetter, actionType) => {
    const scrollHeight = scrollRef.current.scrollHeight;
    const clientHeight = scrollRef.current.clientHeight;

    if (actionType === "Down") {
      let CHeight = clientHeight / 5;
      scrollRef.current.scrollTop = scrollRef.current.scrollTop + CHeight;
    }
    if (actionType === "Up") {
      let CHeight = clientHeight / 5;
      scrollRef.current.scrollTop = scrollRef.current.scrollTop - CHeight;
    }

    const scrollValue = Math.round(
      (scrollRef.current.scrollTop / (scrollHeight - clientHeight)) * 59
    );

    setMScrollPossition(minuteScrollRef.current.scrollTop);
    scrollValueSetter(scrollValue);
  };

  const handleHourScroll = (e, actionType) => {
    if (actionType) {
      handleScrollHour(hourScrollRef, setSelectedHour, actionType);
    } else {
      handleScrollHour(hourScrollRef, setSelectedHour);
    }
  };

  const handleMinuteScroll = (e, actionType) => {
    if (actionType) {
      handleScroll(minuteScrollRef, setSelectedMinute, actionType);
    } else {
      handleScroll(minuteScrollRef, setSelectedMinute);
    }
  };

  return (
    <>
      <div className={`relative m-0 `}>
        <div className="absolute inset-y-0 h-full sm:ps-[10px] ps-[16px] flex items-center">
          <WatchIcon
            className="cursor-pointer"
            onClick={() => setShowTimePicker(!showTimePicker)}
          />
        </div>
        <input
          ref={inputRef}
          type="text"
          className="w-full text-heading_color text-small2 sm:text-small1 p-[13px] sm:p-[11px] py-[5px] sm:py-[3px] ps-[42px] sm:ps-[36px] px-[14px] sm:px-[16.5px] focus:outline-none focus:border-0 rounded-lg bg-light_bg_v4 "
          placeholder={"Select Time"}
          value={`${selectedHour}:${selectedMinute
            .toString()
            .padStart(2, "0")} ${selectedPeriod}`}
          onClick={() => setShowTimePicker(true)}
          readOnly
        />
        <div
          onClick={() => setShowTimePicker(!showTimePicker)}
          className="text-2xl absolute end-0 inset-y-0 h-full sm:pe-[10px] pe-[16px] flex items-center font-semibold text-heading_color cursor-pointer"
        >
          <HiChevronDown />
        </div>
      </div>

      {showTimePicker && (
        <div className="w-full mt-[5px] z-10 bg-light_bg_v5 border border-light_bg_v4 rounded-lg p-[18px]">
          <h2 className="mb-2.5 text-small1_bold text-main_color"> Time </h2>
          <div className="flex items-start gap-2.5 mb-1">
            {openHour ? (
              <div className="picker w-full border rounded-lg bg-white text-center p-0.5">
                <div
                  className={`w-full text-lg flex justify-center items-center py-0.5 cursor-pointer ${
                    hScrollPossition === 0 ? "opacity-20" : "opacity-100"
                  }`}
                  onClick={(e) => handleHourScroll(e, "Up")}
                >
                  <IoIosArrowUp />
                </div>
                <div
                  className="scroll-wheel overflow-y-scroll no-scrollbar h-[200px] flex flex-col justify-start items-center p-2 gap-2"
                  onScroll={handleHourScroll}
                  ref={hourScrollRef}
                >
                  {Array.from(Array(13).keys()).map((hour) => (
                    <div
                      key={hour}
                      onClick={() => {
                        setSelectedHour(hour);
                        setOpenHour(false);
                      }}
                      className={`scroll-item cursor-pointer p-1.5 rounded-full hover:bg-[#FF5349] hover:text-white h-9 w-9 ${
                        hour % 12 === selectedHour % 12
                          ? "selected p-1.5 rounded-full bg-[#FF5349] text-white h-9 w-9"
                          : ""
                      }`}
                    >
                      {hour % 12
                        ? (hour % 12).toString().padStart(2, "0")
                        : "12"}
                    </div>
                  ))}
                </div>
                <div
                  className={`w-full text-lg flex justify-center items-center py-0.5 cursor-pointer ${
                    hScrollPossition === 380 ? "opacity-20" : "opacity-100"
                  }`}
                  onClick={(e) => handleHourScroll(e, "Down")}
                >
                  <IoIosArrowDown />
                </div>
              </div>
            ) : (
              <div
                onClick={() => setOpenHour(true)}
                className="picker w-full border rounded-lg bg-white p-[6px] px-2.5 text-center"
              >
                <div className="flex justify-between items-center">
                  <div className="text-heading_color text-small3_b"> Hrs </div>
                  <div
                    onClick={() => setOpenHour(!openPeriod)}
                    className="text-xl cursor-pointer text-heading_color "
                  >
                    <HiChevronDown />
                  </div>
                </div>
              </div>
            )}
            {openMin ? (
              <div className="picker w-full border rounded-lg bg-white text-center p-0.5">
                <div
                  className={`w-full text-lg flex justify-center items-center py-0.5 cursor-pointer ${
                    mScrollPossition === 0 ? "opacity-20" : "opacity-100"
                  }`}
                  onClick={(e) => handleMinuteScroll(e, "Up")}
                >
                  <IoIosArrowUp />
                </div>
                <div
                  className="scroll-wheel snap-y overflow-y-scroll no-scrollbar h-[200px] flex flex-col justify-start items-center p-2 gap-2"
                  onScroll={handleMinuteScroll}
                  ref={minuteScrollRef}
                >
                  {Array.from(Array(60).keys()).map((minute) => (
                    <div
                      key={minute}
                      onClick={() => {
                        setSelectedMinute(minute);
                        setOpenMin(false);
                      }}
                      className={`scroll-item cursor-pointer  p-1.5 h-9 w-9 rounded-full hover:bg-[#FF5349] hover:text-white ${
                        minute === selectedMinute
                          ? "selected selected p-1.5 h-9 w-9 rounded-full bg-[#FF5349] text-white"
                          : ""
                      }`}
                    >
                      {minute.toString().padStart(2, "0")}
                    </div>
                  ))}
                </div>
                <div
                  className={`w-full text-lg flex justify-center items-center py-0.5 cursor-pointer ${
                    mScrollPossition === 2448 ? "opacity-20" : "opacity-100"
                  }`}
                  onClick={(e) => handleMinuteScroll(e, "Down")}
                >
                  <IoIosArrowDown />
                </div>
              </div>
            ) : (
              <div
                onClick={() => setOpenMin(true)}
                className="picker w-full border rounded-lg bg-white p-[6px] px-2.5  text-center"
              >
                <div className="flex justify-between items-center">
                  <div className="text-heading_color text-small3_b"> Min </div>
                  <div
                    onClick={() => setOpenMin(true)}
                    className="text-xl cursor-pointer text-heading_color "
                  >
                    <HiChevronDown />
                  </div>
                </div>
              </div>
            )}
            {openPeriod ? (
              <div className="picker w-full border rounded-lg bg-white p-2 text-center">
                <div className="">
                  <div
                    onClick={() => {
                      setSelectedPeriod("AM");
                      setOpenPeriod(false);
                    }}
                    className={`scroll-item cursor-pointer p-1 hover:rounded-md hover:bg-[#ff52497e] hover:text-white ${
                      selectedPeriod === "AM"
                        ? " p-1 rounded-md bg-[#FF5349] text-white"
                        : ""
                    }`}
                  >
                    AM
                  </div>
                  <div
                    onClick={() => {
                      setSelectedPeriod("PM");
                      setOpenPeriod(false);
                    }}
                    className={`scroll-item cursor-pointer mt-1 p-1 hover:rounded-md hover:bg-[#ff52497e] hover:text-white ${
                      selectedPeriod === "PM"
                        ? " p-1 rounded-md bg-[#FF5349] text-white"
                        : ""
                    }`}
                  >
                    PM
                  </div>
                </div>
              </div>
            ) : (
              <div
                onClick={() => setOpenPeriod(true)}
                className="picker w-full border rounded-lg bg-white p-[6px] px-2.5 text-center"
              >
                <div className="flex justify-between items-center">
                  <div className="text-small3_b text-heading_color">
                    {selectedPeriod}
                  </div>
                  <div
                    onClick={() => setOpenPeriod(!openPeriod)}
                    className="text-xl cursor-pointer text-heading_color "
                  >
                    <HiChevronDown />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default TimePicker;
